// ─── Semantic theme tokens ─────────────────────────────────────────────────────
// All values are plain strings so the same Theme object works for both
// web (React.CSSProperties) and native (StyleSheet values).

export interface Theme {
  dark: boolean;
  // Surfaces
  bg: string;        // app / page background
  surface: string;   // card / panel
  surfaceAlt: string; // input / nested panel
  // Borders & dividers
  border: string;
  // Text
  text: string;
  textSecondary: string;
  textMuted: string;
  // Brand / interactive
  primary: string;
  primaryText: string; // text placed on a primary-coloured background
  // Semantic
  danger: string;
  dangerBg: string;
  dangerText: string;
  success: string;
  successText: string;
}

// ─── Built-in presets ──────────────────────────────────────────────────────────

export const lightTheme: Theme = {
  dark: false,
  bg:          '#ffffff',
  surface:     '#f1f5f9',
  surfaceAlt:  '#ffffff',
  border:      '#cbd5e1',
  text:        '#1e293b',
  textSecondary: '#475569',
  textMuted:   '#94a3b8',
  primary:     '#6366f1',
  primaryText: '#ffffff',
  danger:      '#ef4444',
  dangerBg:    '#fee2e2',
  dangerText:  '#b91c1c',
  success:     '#22c55e',
  successText: '#ffffff',
};

export const darkTheme: Theme = {
  dark: true,
  bg:          '#0f172a',
  surface:     '#1e293b',
  surfaceAlt:  '#334155',
  border:      '#475569',
  text:        '#f8fafc',
  textSecondary: '#cbd5e1',
  textMuted:   '#64748b',
  primary:     '#818cf8',
  primaryText: '#0f172a',
  danger:      '#f87171',
  dangerBg:    '#450a0a',
  dangerText:  '#fca5a5',
  success:     '#4ade80',
  successText: '#052e16',
};
